<template>
  <div class="ess-roster_leave_settings pt-4">
    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">

      <template v-if="leave_available.length > 0">
        <template v-if="startDate.length > 0">

          <!-- ============================================================ -->
          <!-- Leave application form + other applications table             -->
          <!-- ============================================================ -->
          <div class="row">

            <!-- Application form -->
            <div class="col-sm-7">
              <div class="ess-roster-leave-application pt-3 rounded">
                <div class="card-header rounded border-0 text-muted mx-3 date-0 text-center py-2 d-flex align-items-center justify-content-center">
                  <img src="/images/la/Leave-Application.svg" alt="" class="mr-2">
                  <div>
                    (Leave Year/Contract Date Range From <strong>{{ startDate }}</strong> To <strong>{{ endDate }}</strong>)
                  </div>
                </div>

                <div class="card-body">
                  <b-alert show variant="danger" v-for="error in errors" :key="error">{{ error }}</b-alert>

                  <!-- Read-only date range (edit mode, before "Change Date / Type") -->
                  <div v-if="toggle_reset" class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text">
                        <b-input-group class="mb-3">
                          <b-form-input v-model="day_one" type="text" disabled></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </div>

                    <div class="col-12 col-md-6">
                      <b-form-group id="day_two-group" label="To [YYYY-MM-DD]" label-for="day_two_text">
                        <b-input-group class="mb-3">
                          <b-form-input v-model="day_two" type="text" disabled></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </div>
                  </div>

                  <!-- Leave day / type / date range selectors -->
                  <div class="row" :class="editable">

                    <div class="col-12 col-md-6">
                      <b-form-group class="w-100" label="Leave Day" label-for="leave_day">
                        <b-form-select
                          id="leave_day"
                          name="leave_day"
                          v-model="fdata.leave_day"
                          :options="leaveDay"
                          :disabled="toggle_reset"
                          @change="reloadType"
                        ></b-form-select>
                      </b-form-group>
                    </div>

                    <div class="col-12 col-md-6">
                      <b-form-group
                        id="leave_type_id-group"
                        label="Leave Category"
                        class="required-field w-100"
                        label-for="leave_type_id"
                      >
                        <b-form-select
                          id="leave_type_id"
                          name="leave_type_id"
                          v-model="fdata.leave_type_id"
                          :disabled="toggle_reset"
                          v-validate="{ required: true }"
                          :state="validateState('leave_type_id')"
                          @change="updateToDate"
                          aria-describedby="leave_type_id-feedback"
                          data-vv-as="Leave Category"
                        >
                          <b-form-select-option
                            v-for="leave_type in leavetypes"
                            :key="leave_type.leave_type_id"
                            :value="leave_type.leave_type_id"
                          >{{ leave_type.leave_type_title }}</b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback id="leave_type-feedback">{{ veeErrors.first('leave_type_id') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </div>

                    <div class="col-12 col-md-6" v-if="fdata.leave_type_id != null">
                      <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text" class="required-field">
                        <b-input-group class="mb-3">
                          <b-form-input
                            id="day_one_text"
                            name="day_one_text"
                            v-model="day_one"
                            :disabled="period_date != undefined"
                            v-validate="{ required: true }"
                            type="text"
                            placeholder="YYYY-MM-DD"
                            autocomplete="off"
                            @change="updateToDate"
                            :state="validateState('day_one_text')"
                            aria-describedby="day_one_text-feedback"
                            data-vv-as="From Date"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              id="day_one"
                              v-model="day_one"
                              :disabled="period_date != undefined"
                              @context="updateToDate()"
                              button-only
                              right
                              locale="en-US"
                              :date-disabled-fn="dateDisabled"
                              :start-weekday="fetchStartWeekday"
                            ></b-form-datepicker>
                          </b-input-group-append>
                          <b-form-invalid-feedback id="day_one_text-feedback">{{ veeErrors.first('day_one_text') }}</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </div>

                    <div
                      class="col-12 col-md-6"
                      :class="{ 'd-none': fdata.leave_day > 0 }"
                      v-if="fdata.leave_type_id != null"
                    >
                      <b-form-group id="day_two-group" label="To [YYYY-MM-DD]" label-for="day_two_text" class="required-field">
                        <b-input-group class="mb-3">
                          <b-form-input
                            id="day_two_text"
                            name="day_two_text"
                            v-model="day_two"
                            :disabled="period_date != undefined || (leaveType != null && leaveType.event > 0)"
                            v-validate="{ required: true }"
                            type="text"
                            placeholder="YYYY-MM-DD"
                            autocomplete="off"
                            @change="adjustValidDate"
                            :state="validateState('day_two_text')"
                            aria-describedby="day_two_text-feedback"
                            data-vv-as="To Date"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              id="day_two"
                              v-model="day_two"
                              :disabled="period_date != undefined || (leaveType != null && leaveType.event > 0)"
                              @context="adjustValidDate()"
                              button-only
                              right
                              locale="en-US"
                              :min="min"
                              :date-disabled-fn="dateDisabled"
                              :start-weekday="fetchStartWeekday"
                            ></b-form-datepicker>
                          </b-input-group-append>
                          <b-form-invalid-feedback id="day_two_text-feedback">{{ veeErrors.first('day_two_text') }}</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </div>
                  </div>

                  <!-- Shift selection, attachment, comment, action buttons -->
                  <div class="my-2" v-if="fdata.leave_type_id != null">
                    <div class="row">

                      <div class="col-sm-12">
                        <template v-if="is_roster && this.day_one">
                          <p class="mb-1">Select Assigned Shift</p>

                          <div
                            v-if="this.assignments.length > 0"
                            class="position-relative mb-3"
                            ref="assignment_dropdown"
                          >
                            <button
                              type="button"
                              class="form-control d-flex justify-content-between align-items-center text-left overflow-hidden bg-white cursor-pointer assignment-toggle"
                              @click.prevent="toggleAssignmentDropdown"
                            >
                              <span
                                class="assignment-toggle-label d-block overflow-hidden"
                                :class="selectedAssignments.length ? 'has-selection' : 'is-placeholder text-muted'"
                              >
                                {{ selectedAssignments.length ? getSelectedAssignmentNames() : 'Select shift(s)' }}
                              </span>
                              <b-icon class="ml-3 assignment-toggle-caret custom-caret" icon="chevron-down" style="color: #3A52A6;"></b-icon>
                            </button>

                            <div v-if="openAssignmentDropdown" class="assignment-menu position-absolute rounded p-2 bg-white border">
                              <label
                                v-for="s in assignments"
                                :key="s.id"
                                class="assignment-option d-flex align-items-center cursor-pointer p-1 m-0 font-weight-normal rounded"
                              >
                                <input
                                  class="assignment-checkbox cursor-pointer"
                                  type="checkbox"
                                  :value="s.id"
                                  v-model="selectedAssignments"
                                />
                                <span class="ml-2">
                                  {{ moment(s.period_date).format('YYYY-MM-DD') }} |
                                  {{ s.shift ? s.shift.code : '' }} |
                                  {{ s.shift ? s.shift.start_time : '' }} →
                                  {{ s.shift ? s.shift.end_time : '' }}
                                  <template v-if="s.shift">({{ s.shift.name }})</template>
                                </span>
                              </label>
                            </div>
                          </div>

                          <div v-else>
                            <p class="text-danger text-center">{{ no_shift_text }}</p>
                          </div>
                        </template>
                      </div>

                      <div class="col-12 col-md-6">
                        <b-form-group id="comment-group" class="required-field" label="Reason/Comment" label-for="comment">
                          <b-form-textarea
                            id="comment"
                            name="comment"
                            rows="3"
                            max-rows="6"
                            no-resize
                            v-model="fdata.comment"
                            v-validate="{ required: true, min: 3 }"
                            :state="validateState('comment')"
                            aria-describedby="comment-feedback"
                            data-vv-as="Reason/Comment"
                          ></b-form-textarea>
                          <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                        </b-form-group>
                      </div>

                      <div class="col-12 col-md-6">
                        <b-form-group id="attachment-group" label="Attachment" label-for="attachment">
                          <b-form-file
                            id="attachment"
                            v-model="attachment"
                            @change="checkFileType($event , 'attachment', ['.jpg', '.png', '.gif', '.pdf'])"
                            accept=".jpg, .png, .gif, .pdf"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            aria-describedby="form_etin_scan-feedback"
                            data-vv-as="Attachment"
                          ></b-form-file>
                        </b-form-group>
                      </div>

                    </div>

                    <div class="clearfix">
                      <template v-if="show_reset == 1">
                        <div class="float-left mr-2">
                          <b-button v-if="toggle_reset" @click="changeDate" type="button">Change Date / Type</b-button>
                          <b-button v-else @click="resetChangeDate" type="button">Reset</b-button>
                        </div>

                        <b-button @click="deleteLeave" type="button" class="mx-2">Delete</b-button>
                      </template>

                      <div class="text-center">
                        <b-button @click="saveLeave" class="px-4" :disabled="disable_flg">Save</b-button>
                      </div>

                      <div v-if="(dateDiff || days) && day_one" class="float-right font-italic" :class="my_class">
                        <span v-if="!is_roster">Affected Day(s) :</span>
                        <span v-else>Affected Shift(s) :</span>
                        <span v-if="toggle_reset">{{ days }}</span>
                        <span v-else>{{ dateDiff }}</span>
                      </div>
                      <div v-if="excess" class="float-right font-italic mx-2" :class="my_class">Exceeded Leave!</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Other leave applications -->
            <div class="col-sm-5">
              <div class="card no-shadow border-0">
                <h5 class="content-div-title">Leave Balance <i class="font-weight-normal">(In Days)</i></h5>
                <div class="row">
                  <div class="col-sm-12">
                    <table class="table">
                      <thead>
                        <tr class="table-head">
                          <th>Leave Category</th>
                          <th>Leaves Applied</th>
                          <th>Leaves Taken</th>
                          <th>Leaves Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
                          <td>
                            <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                            {{ leave_type.leave_title }}
                          </td>
                          <td>
                            {{ leave_type.applied }}
                            <span v-if="leave_type.basis == 1">Shifts</span>
                            <span v-else>Days</span>
                          </td>
                          <td>
                            {{ leave_type.enjoyed }}
                            <span v-if="leave_type.basis == 1">Shifts</span>
                            <span v-else>Days</span>
                          </td>
                          <td>
                            {{ leave_type.remaining }}
                            <span v-if="leave_type.basis == 1">Shifts</span>
                            <span v-else>Days</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </template>

        <template v-else>
          <div class="vertical-center">
            <div class="container font-weight-bold text-danger">
              No active contract found.
            </div>
          </div>
        </template>
      </template>

      <template v-else-if="has_contract == false">
        <div class="vertical-center">
          <div class="container font-weight-bold text-danger">
            No active contract found.
          </div>
        </div>
      </template>

      <template v-else>
        <div class="vertical-center" v-if="show_warning">
          <div class="container font-weight-bold text-danger">
            No leave policy defined or assigned leave policy doesn't have any day amount defined or leave year not unlocked!
          </div>
        </div>
      </template>

      <roster-ess-leave-balance-card></roster-ess-leave-balance-card>

    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment'

export default {

  props: [
    'editflg',
    'leave_type_id',
    'flg_status',
    'from',
    'to',
    'attendances_date',
    'leave_day',
    'period_date',
  ],

  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDateStr = new Date(today.getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10)

    return {
      // ---- UI state ----
      showoverlay: false,
      loading: false,
      disable_flg: false,
      openAssignmentDropdown: false,
      no_shift_text: 'Loading...',
      blankmsg: 'Fetching data..',
      my_class: '',
      editable: '',
      ce: true,
      show_reset: 0,
      toggle_reset: false,
      show_warning: false,
      show_form: false,
      mode: 0,
      errors:[],

      // ---- Date range / calendar ----
      startDate: '',
      endDate: '',
      min: minDateStr,
      day_one: '',
      day_two: '',
      days: 0,
      is_holiday: false,
      all_week_holidays: [],
      holidays_date_arr: [],
      skip_days: [],
      off_day_on_leave: 0,

      // ---- Form data ----
      fdata: {
        leave_day: 0,
        day_one: this.day_one,
        day_two: this.day_two,
        days: null,
        leave_type_id: null,
        flg_status: 0,
        comment: null,
        is_roster: 1,
      },
      attachment: null,
      ids: 0,

      // ---- Leave data ----
      leaves: [],
      leave_limit: [],
      leave_available: [],
      // 05 jul 2026: object keyed by leave_type_id (was []); backend serializes
      // a keyed PHP array as a JSON object, so .includes() crashed on real data
      excess_leaves: {},
      excess: false,
      leave_events: [],
      leave_details: {},
      leavetypes: [],
      has_contract: true,
      company_id: 0,

      // ---- Shift assignment ----
      assignments: [],
      selectedAssignments: [],
      unassigned_employees: [],
      selected_unassigned_employees: {},
      employeeLeaveDetails: {
        leave: null,
        employee: '',
        department: '',
        jobposition: '',
        leaveType: '',
        duration: '',
        period: '',
        reason: '',
        shifts: [],
      },

      // ---- Static option lists ----
      count_options: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
      ],
      options: [
        { text: 'Friday', value: '5' },
        { text: 'Saturday', value: '6' },
        { text: 'Sunday', value: '0' },
        { text: 'Monday', value: '1' },
        { text: 'Tuesday', value: '2' },
        { text: 'Wednesday', value: '3' },
        { text: 'Thursday', value: '4' },
      ],
      leavestatus: [
        { text: 'Applied', value: '0' },
        { text: 'Approved', value: '1' },
        { text: 'Declined', value: '2' },
      ],
      leaveDay: [
        { text: 'Full Day', value: '0' },
        { text: 'First Half', value: '1' },
        { text: 'Second Half', value: '2' },
      ],
    }
  },

  computed: {
    leaveType() {
      let type = this.leavetypes.find(({ leave_type_id }) => leave_type_id == this.fdata.leave_type_id);
      return type || null;
    },

    is_roster() {
      let type = this.leaveType;
      if (type) {
        return type.leave_basis;
      }
      return 0;
    },

    dateDiff() {
      this.disable_flg = false;
      this.my_class = '';
      this.excess = false;

      if (this.fdata.leave_type_id == null) {
        return '';
      }

      let days = 0;

      if (this.is_roster) {
        if (this.selectedAssignments.length <= 0) {
          this.fdata.days = 0;
          return '';
        }
        days = this.selectedAssignments.length;
        this.fdata.days = days;
      } else {
        if (!this.day_one || !this.day_two) {
          this.fdata.days = 0;
          this.disable_flg = true;
          this.my_class = 'danger';
          return 'Empty Date!';
        }

        let day_one = moment(this.day_one);
        let day_two = moment(this.day_two);

        if (!day_one.isValid() || !day_two.isValid()) {
          this.fdata.days = 0;
          this.disable_flg = true;
          this.my_class = 'danger';
          return 'Invalid Date Range';
        }

        this.fdata.day_one = day_one.format('YYYY-MM-DD');
        this.fdata.day_two = day_two.format('YYYY-MM-DD');

        if (this.leaveType != null && this.leaveType.event == 0) {
          if (!this.checkValidDate(this.fdata.day_one) || !this.checkValidDate(this.fdata.day_two)) {
            this.fdata.days = 0;
            this.disable_flg = true;
            this.my_class = 'danger';
            return 'Wrong Leave Year!';
          } else {
            // FIX: previously returned 'Limit exceeded!' here when
            // leave_events[type] === false, blocking the leave before any
            // balance check. Now it falls through to the days<=limit balance
            // check below so remaining balance is respected.
            // (Restore the original early-return if leave_events:false was
            //  meant to be a hard block independent of balance.)
          }
        }

        if (day_two.isBefore(day_one, 'day')) {
          this.fdata.days = 0;
          this.disable_flg = true;
          this.my_class = 'danger';
          return 'Invalid Date Range';
        }

        if (this.leaveType.off_day_on_leave == 1) {
          days = 0;
          for (let m = moment(this.day_one); m.isSameOrBefore(this.day_two, 'day'); m.add(1, 'days')) {
            if (this.skip_days.includes(m.format('YYYY-MM-DD'))) {
              continue;
            }
            days++;
          }
        } else {
          days = day_two.diff(day_one, 'days') + 1;
        }

        this.fdata.days = days;

        if (this.leave_events[this.fdata.leave_type_id] != undefined) {
          if (this.leave_events[this.fdata.leave_type_id] === true) {
            return days;
          }
        }
      }

      if (days <= 0) {
        this.fdata.days = 0;
        this.disable_flg = true;
        this.my_class = 'danger';
        return 'Invalid Date Range';
      }

      let lt = this.fdata.leave_type_id;

      if (!lt) {
        return days;
      }

      let leaveTypeId = Number(lt);
      let limit = this.leave_limit[leaveTypeId] || 0;

      if (days <= limit) {
        this.excess = false;
        return days;
      }

      // 05 jul 2026: excess_leaves is a keyed object {leave_type_id: bool};
      // the previous .includes() call crashed once real data arrived
      if (this.excess_leaves && this.excess_leaves[leaveTypeId] === true) {
        this.excess = true;
        this.my_class = 'danger';
        return days;
      }

      this.disable_flg = true;
      this.my_class = 'danger';
      this.excess = false;
      return 'Limit Exceed!';
    },

    fetchStartWeekday() {
      return this.week_start_day;
    },
  },

  created: function () {
    this.getEmployeeLeaveSettings();
    this.getDisabledDates();

    if (this.period_date) {
      this.day_one = this.period_date;
      this.day_two = this.period_date;
      this.fdata.day_one = this.period_date;
      this.fdata.day_two = this.period_date;
    }

    if (this.editflg == 1) {
      this.fetchLeavesByRangeTypeStatus();
      this.toggle_reset = true;
    } else if (this.attendances_date != null) {
      this.fdata.day_one = this.attendances_date;
      this.day_one = this.attendances_date;
    }
  },

  mounted() {
    document.addEventListener('click', this.closeAssignmentDropdown);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeAssignmentDropdown);
  },

  methods: {
    moment,

    // ---------------------------------------------------------------
    // Form / type helpers
    // ---------------------------------------------------------------
    reloadType: function () {
      var x = this.fdata.leave_day;
      if (x > 0) {
        this.fdata = { leave_day: x, day_one: this.day_one, day_two: this.day_one, days: null, leave_type_id: null, flg_status: 0, comment: null };
        this.day_two = this.day_one;
      }
      // this.getLeaves();
      this.getLeaveTypeByLeavePolicy(x);
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    checkFileType(e) {
      const f = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
      if (!f) return;
      const ok = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
      if (!ok.includes(f.type)) {
        this.$bvToast.toast('Unsupported file type.', { variant: 'danger', solid: true });
        this.attachment = null;
      }
    },

    // ---------------------------------------------------------------
    // Assignment dropdown
    // ---------------------------------------------------------------
    closeAssignmentDropdown(event) {
      if (
        this.$refs.assignment_dropdown &&
        !this.$refs.assignment_dropdown.contains(event.target)
      ) {
        this.openAssignmentDropdown = false;
      }
    },

    toggleAssignmentDropdown() {
      this.openAssignmentDropdown = !this.openAssignmentDropdown;
    },

    getSelectedAssignmentNames() {
      return this.assignments
        .filter(s => this.selectedAssignments.includes(s.id))
        .map(s => {
          let shift = s.shift || {};
          return `${moment(s.period_date).format('YYYY-MM-DD')} | ${shift.code || ''}`;
        })
        .join(', ');
    },

    getShiftsDateRange() {
      const start = this.day_one;
      const end = this.day_two;

      if (!start || !end || isNaN(Date.parse(start)) || isNaN(Date.parse(end))) {
        this.assignments = [];
        this.selectedAssignments = [];
        return;
      }

      this.loading = true;

      axios.get(this.$api_url + '/front/leave-attendance/shift-by-date-range', {
        params: { start, end, day: this.fdata.leave_day }
      }).then(res => {
        this.assignments = res.data;
        if (this.assignments.length == 0) {
          this.no_shift_text = 'This date is not available for leave application.';
        }
        this.selectedAssignments = [];
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.serverError(err);
      });
    },

    // ---------------------------------------------------------------
    // Date helpers
    // ---------------------------------------------------------------
    formatdate: function (x) {
      return moment(x).format('YYYY-MM-DD');
    },

    checkGaterDate(x) {
      return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
    },

    isPastDate(date) {
      if (!date) return false;
      return moment(date, 'YYYY-MM-DD').isBefore(moment(), 'day');
    },

    checkValidDate(date) {
      if (!this.startDate || !this.endDate) return true;
      return this.startDate <= date && date <= this.endDate;
    },

    dateDisabled(ymd, date) {
      const x = moment(String(date)).format('YYYY-MM-DD');
      if (this.leaveType != null && this.leaveType.event == 0) {
        if (this.startDate && this.endDate) {
          if (x < this.startDate || x > this.endDate) {
            return true;
          }
        }
      }
      if (this.is_holiday) {
        return this.all_week_holidays.includes(x) || this.holidays_date_arr.includes(x) || this.skip_days.includes(x);
      } else {
        return false;
      }
    },

    updateToDate: function () {
      if(!this.day_one) return;
      if (this.leaveType != null) {
        const isEvent = this.leaveType.event;

        if (isEvent > 0) {
          this.min = this.day_one;

          if (this.day_one) {
            this.day_two = moment(this.day_one, 'YYYY-MM-DD').add(Number(this.leaveType.leave_days) - 1, 'days').format('YYYY-MM-DD');
          }

          this.fdata.day_one = this.day_one;
          this.fdata.day_two = this.day_two;

          if (this.is_roster) {
            this.getShiftsDateRange();
          }
        } else {
          this.min = this.day_one;

          if (this.leaveType && this.leaveType.off_day_on_leave == 2) {
            this.pushBackStartDate(this.day_one);
          } else {
            this.day_two = this.day_one;
          }

          this.fdata.day_one = this.day_one;
          this.fdata.day_two = this.day_two;
        }
      }
    },

    pushBackStartDate: function (x) {
      let m = moment(x);
      m.add(-1, 'days');
      if (this.skip_days.includes(m.format('YYYY-MM-DD'))) {
        this.day_two = '';
        this.day_one = m.format('YYYY-MM-DD');
        this.pushBackStartDate(this.day_one);
      }
    },

    adjustValidDate: function () {
      if (moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD'))) {
        this.day_two = this.day_one;
      }
      else if (
        !this.leaveType?.event &&
        moment(this.day_two).isAfter(moment(this.endDate).format('YYYY-MM-DD'))
      ) {
        this.day_two = this.day_one;
      }
      else {
        if (this.leaveType && this.leaveType.off_day_on_leave == 2) {
          let n = moment(this.day_two);
          n.add(1, 'days');
          if (this.skip_days.includes(n.format('YYYY-MM-DD'))) {
            this.day_two = n.format('YYYY-MM-DD');
            this.adjustValidDate();
          }
        }
      }

      if (this.is_roster) this.getShiftsDateRange();
    },

    // ---------------------------------------------------------------
    // Data fetching
    // ---------------------------------------------------------------
    getEmployeeLeaveSettings: function () {
      axios.get(this.$api_url + '/front/leave-attendance/employee/leave/settings').then((response) => {
        if (response.data.length != 0) {
          this.company_id = response.data.company_id;
          this.week_start_day = response.data.week_start_day;
          this.is_holiday = response.data.is_holiday;
          this.skip_days = String(response.data.skip_days).split(',').filter(Boolean);
          this.getLeaves();
          this.getLeaveTypeByLeavePolicy();
        }
      });
    },

    getDisabledDates: function () {
      axios.get(this.$api_url + '/front/leave-attendance/holidays/details').then(function (response) {
        if (response.data.length != 0) {
          this.all_week_holidays = response.data.report.week_holidays;
          this.week_start_day = response.data.report.week_start_day;
          this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function (item) { return item; });
        }
      }.bind(this));
    },

    getLeaveTypeByLeavePolicy: function (f = 0) {
      if (!this.checkNet()) return false;

      axios.get(this.$api_url + '/front/leave-attendance/leave/type/policy?f=' + f).then((response) => {
        this.leavetypes = response.data;
        this.show_warning = this.leavetypes.length <= 0;
      });
    },

    getLeaves: function () {
      this.showoverlay = true;
      axios.get(this.$api_url + '/front/leave-attendance/employee/leaves').then((response) => {
        if (response.data.length != 0) {
          this.leaves = response.data.leave_data || [];
          this.leave_limit = response.data.limit || [];
          this.leave_available = response.data.available || [];
          // 05 jul 2026: default {} to match the keyed-object shape
          this.excess_leaves = response.data.excess_leaves || {};

          this.startDate = response.data.range.leave_limit_start_date || '';
          this.endDate = response.data.range.leave_limit_end_date || '';
          this.leave_events = response.data.leave_events;

          if (this.leaves.length == 0) {
            this.blankmsg = 'Looks like no leave applied for the employee yet.';
          }

          this.show_warning = this.leave_limit.length == 0;
          this.has_contract = true;
        }
        else {
          this.has_contract = false;
        }

        this.showoverlay = false;
      }).catch((error) => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    fetchLeavesByRangeTypeStatus: function () {
      this.day_one = this.from;
      this.day_two = this.to;
      this.fdata.leave_type_id = this.leave_type_id;

      let formData = new FormData();
      formData.append('leave_type_id', this.leave_type_id);
      formData.append('flg_status', this.flg_status);
      formData.append('from', this.from);
      formData.append('to', this.to);

      axios.post(this.$api_url + '/front/leave-attendance/employee/leaves/range', formData).then((response) => {
        this.fdata.comment = response.data.comment;
        this.fdata.flg_status = response.data.flg_status;
        this.days = response.data.days;
        this.ids = response.data.ids;
        this.show_reset = 1;
      }).catch((error) => {
        this.serverError(error);
      });
    },

    // ---------------------------------------------------------------
    // Edit mode (change date / reset)
    // ---------------------------------------------------------------
    resetChangeDate: function () {
      this.showoverlay = true;
      this.toggle_reset = !this.toggle_reset;

      this.getEmployeeLeaveSettings();
      this.getLeaveTypeByLeavePolicy();
      this.getLeaves();

      if (this.editflg == 1) {
        this.fetchLeavesByRangeTypeStatus();
      }

      setTimeout(() => { this.showoverlay = false; }, 1000);
    },

    changeDate: function () {
      this.showoverlay = true;
      this.editable = '';

      this.toggle_reset = !this.toggle_reset;
      this.fdata.flg_status = 0;

      this.leave_available.forEach((element, index) => {
        if (element.leave_type_id == this.leave_type_id) {
          this.leave_available[index].remaining_days = this.leave_available[index].remaining_days + this.days;
          this.leave_limit[this.leave_type_id] = (this.leave_limit[this.leave_type_id]) + this.days;
        }

        this.day_one = this.from;
        this.fdata.leave_type_id = this.leave_type_id;
        setTimeout(() => { this.showoverlay = false; }, 1000);
        this.day_two = this.to;
      });

      this.showoverlay = false;
    },

    // ---------------------------------------------------------------
    // Leave CRUD
    // ---------------------------------------------------------------
    deleteLeave: function () {
      this.showoverlay = true;
      let formData = new FormData();
      formData.append('leave_type_id', this.leave_type_id);
      formData.append('flg_status', this.flg_status);
      formData.append('from', this.from);
      formData.append('to', this.to);

      axios.post(this.$api_url + '/front/leave-attendance/leave/delete/range', formData).then((response) => {
        this.$bvToast.toast('Deleted!', {
          title: `Success`,
          variant: 'success',
          solid: true
        });

        setTimeout(() => {
          this.$emit('childToParent');
          this.showoverlay = false;
        }, 1000);
      }).catch((error) => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    saveLeave: function () {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        if (this.is_roster) {
          if (this.selectedAssignments.length == 0) {
            this.disable_flg = true;
            this.$bvToast.toast('No shifts selected', {
              solid: true,
              title: 'Failed',
              variant: 'danger'
            });
            this.disable_flg = false;
            return;
          }

          if (this.selectedAssignments.length > 1 && this.fdata.leave_day > 0) {
            this.disable_flg = true;
            this.$bvToast.toast('Half day leave cannot be applied on more than one shift.', {
              solid: true,
              title: 'Failed',
              variant: 'danger'
            });
            this.disable_flg = false;
            return;
          }

          let selected = this.assignments.filter(({ id }) => this.selectedAssignments.includes(id));
          if (selected.length) {
            let dates = selected.map(s => new Date(s.period_date).getTime());
            let day_one = new Date(Math.min(...dates));
            let day_two = new Date(Math.max(...dates));

            // keep both fdata and local inputs in sync
            this.fdata.day_one = day_one.toISOString().split('T')[0];
            this.fdata.day_two = day_two.toISOString().split('T')[0];
            this.day_one = this.fdata.day_one;
            this.day_two = this.fdata.day_two;
          }
        }

        let formData = new FormData();

        if (this.editflg == 1) {
          formData.append('ids', this.ids);
        }

        if (!this.toggle_reset) {
          formData.append('removeids', this.ids);
        }

        for (let [key, value] of Object.entries(this.fdata)) {
          var nm = `${key}`;
          var fval = `${value}`;
          formData.append(nm, fval);
        }

        if (this.attachment) {
          formData.append('attachment', this.attachment);
        }
        formData.append('assignment_ids', JSON.stringify(this.selectedAssignments));

        this.showoverlay = true;

        axios.post(this.$api_url + '/front/leave-attendance/employee/leaves/save', formData).then((response) => {
          if(response.data.errors) {
            this.errors = response.data.errors;
            this.showoverlay = false;
          } else {
            this.$bvToast.toast('Saved!', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            setTimeout(() => {
              this.$emit('childToParent');
              this.$emit('hideModal');
              this.$bvModal.hide('bv-modal-add-leave');
              this.showoverlay = false;
            }, 1000);
          }
        }).catch((error) => {
          this.showoverlay = false;
          this.serverError(error);
        });
      });
    },
  },
}
</script>
